import { render } from "./DetalhePicking.vue?vue&type=template&id=a6168220&scoped=true"
import script from "./DetalhePicking.vue?vue&type=script&lang=js"
export * from "./DetalhePicking.vue?vue&type=script&lang=js"

import "./DetalhePicking.vue?vue&type=style&index=0&id=a6168220&scoped=true&lang=css"
import "./DetalhePicking.vue?vue&type=style&index=1&id=a6168220&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6168220"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QTable,QBtn,QCardSection,QSelect,QTd,QTooltip,QDialog,QCard,QIcon,QField});
